module.exports = __webpack_public_path__ + "static/media/cp13.5cf5b241.pdf";